import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import { addEventListener, debounce } from '@ifeng-fe/ui_base';
import EndPage from '../endpage';
import errorBoundary from '@ifeng-fe/errorBoundary';

const getWindowWidth = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (window.innerWidth !== undefined) {
            return window.innerWidth;
        } else {
            const B = document.body;
            const D = document.documentElement;

            return Math.min(D.clientWidth, B.clientWidth);
        }
    }
};

const getHeight = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (window.innerHeight !== undefined) {
            return window.innerHeight;
        } else {
            const B = document.body;
            const D = document.documentElement;

            // return Math.min(D.clientHeight, B.clientHeight);
            return Math.min(947, 947);
        }
    }
};

class LivingSlide extends React.PureComponent {
    static propTypes = {
        slideData: PropTypes.array,
        docData: PropTypes.object,
        recommendData: PropTypes.array,
        footer: PropTypes.object,
    };

    state = {
        current: 1,
        total: this.props.slideData.length,
        winWidth: getWindowWidth(),
        isNomal: true,
    };

    swtichPage = (current, total) => {
        this.setState({
            current: current + 1,
            total,
        });
        window.location.hash = `#p=${current + 1}`;
        window.analytics(encodeURIComponent(window.location.href));
    };

    nextCallback = (index, total) => {
        console.log('next========>');
        console.log(index, total);
        if (index >= total - 1) {
            console.log('已经到最后一张了，停止滑动');

            this.setState({ isNomal: false });

            return false;
        } else {
            return true;
        }
    };

    preCallback = (index, total) => {
        console.log('pre========>');
        console.log(index, total);
        if (index <= 0) {
            console.log('已经到第一张了，停止滑动');

            return false;
        } else {
            return true;
        }
    };

    // 快捷键绑定
    handleKeyDown = e => {
        if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 27) {
            e.preventDefault();
        }

        if (e.keyCode === 37) {
            // this.nextCallback(current, total );
        } else if (e.keyCode === 39) {
            // this.preCallback(current, total);
        }
    };

    sliderTmpl = function sliderTmpl(item) {
        return (
            <a className={styles.slideItem}>
                <img src={item.url} />
            </a>
        );
    };

    resizePic = () => {
        this.setState({
            winWidth: getWindowWidth(),
        });

        // test
    };
    debounceFn = debounce(this.resizePic, 100);

    async componentDidMount() {
        // resize
        this.unresizePic = addEventListener(window, 'resize', this.debounceFn);
        // keydown
        this.unhandleKeyDown = addEventListener(window, 'keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        this.unresizePic();
        this.unhandleKeyDown();
    }

    /**
     * 渲染网页布局
     */
    render() {
        if (typeof window === 'undefined') {
            return '';
        }

        const { slideData, docData, footer, recommendData } = this.props;
        const { total, isNomal } = this.state;
        const scrollWrapW = getWindowWidth();
        const scrollWrapH = getHeight();

        // console.log('scrollWrapW++', scrollWrapW);
        // console.log('scrollWrapH++', scrollWrapH);

        let initialSlide = 0;

        const href = window.location.href;
        const hrefArr = href.split('#');

        if (hrefArr.length > 1 && hrefArr[1].indexOf('p') !== -1) {
            const page = parseInt(hrefArr[1].split('=')[1]);

            if (page <= total) {
                initialSlide = page - 1;
            } else {
                initialSlide = total - 1;
            }
        } else {
            // 没有指定页码时，默认为p=1
            initialSlide = 0;
        }

        window.location.hash = `#p=${initialSlide + 1}`;

        const slideItem = slideData[initialSlide];
        const config = {
            arrows: true,
            extension: 1,
            dots: false,
            autoplay: false,
            autoplayInterval: 3000,
            initialSlide,
            sliderTmpl: this.sliderTmpl,
            beginChange: this.swtichPage,
            unitSize: this.state.winWidth,
            nextCallback: this.nextCallback,
            preCallback: this.preCallback,
        };

        return isNomal ? (
            <div className={styles.LivingContent} onKeyDown={this.handleKeyDown}>
                <div className={styles.wrap}>
                    <div
                        className={styles.scroll_wrap}
                        style={{ height: `${scrollWrapH}px`, width: `${scrollWrapW}px`, maxWidth: `${scrollWrapW}px` }}>
                        <Slides content={slideData} config={config} />

                        <div className={styles.description}>
                            <div className={styles.des_center}>
                                <p className={styles.des}> {slideItem.description} </p>
                                <ul className={styles.scrollIndex}>
                                    <div className={styles.cur_index}>{initialSlide + 1}</div>
                                    <div className={styles.total}>{total}</div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <EndPage content={docData} footer={footer} recommendData={recommendData} />
        );
    }
}

export default errorBoundary(LivingSlide);
